module.exports = __webpack_public_path__ + "img/download-new-white.ad81c357.svg";